import { Component, Input, OnInit } from "@angular/core";
import { tryParseDate } from "src/services/utils/timestamp.utils";
import { Order } from "src/services/order/order.interface";
import { PendingOrder } from "src/services/pending-order/pending-order.interface";
import { orderFormFields } from "./order.form";
import { ServiceType } from "src/services/subscription/plan-service-type.enum";
import { ControlContainer, FormGroup } from "@angular/forms";
import { AuthService } from "src/services/auth/auth.service";

@Component({
  selector: "rc-order-statuses",
  template: `
    <form [formGroup]="form">
      <ion-row [ngClass]="{ 'ion-justify-content-end': alignment === 'right' }">
        <rc-service-type-form-field
          [initialValue]="order?.serviceType"
          [formControlName]="orderFormFields.serviceType"
          [withLabel]="true"
          size="small"></rc-service-type-form-field>
      </ion-row>
      <ion-row [ngClass]="{ 'ion-justify-content-end': alignment === 'right' }">
        <rc-order-status-form-field
          size="small"
          [initialValue]="order?.status"
          [withLabel]="true"
          [formControlName]="orderFormFields.status"
          [readOnly]="!order"></rc-order-status-form-field>
      </ion-row>

      @if (
        currentUserIsAdminOrDriver &&
        (order?.serviceType === ServiceType.firstTimePickup ||
          order?.serviceType === ServiceType.localPickup ||
          order?.serviceType === ServiceType.localDelivery)
      ) {
        <ion-row [ngClass]="{ 'ion-justify-content-end': alignment === 'right' }">
          <rc-order-step-form-field
            size="small"
            [withLabel]="true"
            [formControlName]="orderFormFields.step"
            [order]="order"></rc-order-step-form-field>
        </ion-row>
      }
    </form>
  `,
  styleUrls: ["./full-order-card.component.scss"],
  standalone: false,
})
export class OrderStatusesComponent implements OnInit {
  @Input() alignment: "left" | "right";
  @Input() order: Order | PendingOrder;

  public currentUserIsAdminOrDriver: boolean = false;
  public form: FormGroup;

  constructor(
    private authService: AuthService,
    private controlContainer: ControlContainer,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.form = <FormGroup>this.controlContainer.control;
    this.currentUserIsAdminOrDriver = await this.authService.isActiveUserAdminOrDriver();
  }

  public readonly tryParseDate = tryParseDate;
  public readonly orderFormFields = orderFormFields;
  public readonly ServiceType = ServiceType;
}
